import React from 'react';
import { Input, Spin } from 'antd';
const { TextArea } = Input;
import Group from '../../../../components/Group';
import ScheduledPublishTime from '../../../../components/ScheduledPublishTime';
import toast from '@util/toast';
import './index.scss';
export const ResourceInfo = props => {
    const fileInputChange = e => {
        // 验证图片格式
        const file = e.target.files&&e.target.files[0];
        if (!file) {
            return;
        }
        if (/\.(jpg|jpeg|png)$/i.test(file.name) === false) {
            toast.error('图片验证未通过:不支持该格式');
            return;
        } else if (file.size / 1024 / 1024 > 5) {
            toast.error('上传图片不能超过5M');
            return;
        }
        props.setCover(e.target.files[0]);
    };
    const getIdFromURL = (url = window.location.href) => {
        const parsedUrl = new URL(url);
        return parsedUrl.searchParams.get('id') || '';
    };
    return (
        <div className="resource-info-box">
            <div className="resource-content-box">
                <div>
                    <h3 className="resource-name">视频标题</h3>
                    <div className="resource-description-box">
                        <Input
                            onChange={props.titleChange}
                            value={props.title}
                            maxLength={100}
                            placeholder="好标题能收获更多赞哦~"
                        />
                    </div>
                    <h3 className="resource-name">视频简介</h3>
                    <div className="resource-description-box">
                        <TextArea
                            onChange={props.descChange}
                            value={props.desc}
                            maxLength={10000}
                            placeholder="添加视频简介（0-10000字，选填)"
                            className="resource-description-textarea"
                            rows={14}
                        />
                    </div>
                </div>
                <div className="resource-add-cover-box">
                    <h3 className="resource-name">视频封面</h3>          
                    <Spin spinning={props.isLoading} size="large" >
                        <div
                            className="resource-add-cover"
                            style={{ backgroundColor: '#f5f5f5' }}>
                            <div
                                hidden={props.cover}
                                className="resource-default-cover">
                                <span className="iconfont">&#xe6dc;</span>
                                {/* <div className="button-file-box"> */}
                                {/* </div> */}
                                <p>点击添加封面图片</p>
                                <p>支持JPG、PNG图片</p>
                            </div>
                            <div
                                hidden={!props.cover}
                                className="resource-cover-box">
                                <img src={props.cover} alt="" />
                            </div>
                            <input
                                onChange={fileInputChange}
                                type="file"
                                name=""
                                id=""
                                accept="image/jpg,image/jpeg,image/png"
                            />
                        </div>
                    </Spin>
                </div>
                <div className="recommendation-imgs-box">
                    <div className="recommendation-imgs-wrap">
                        <h3 className="resource-name-title">推荐图片</h3>
                        <div className="recommendation-img">
                            {props.recommendationImgs &&
                                props.recommendationImgs.length > 0 &&
                                props.recommendationImgs.map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            onClick={() =>
                                                props.setCover(item)
                                            }>
                                            {item && <img src={item} alt="" />}
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ marginTop: '10px' }}>
                <span style={{ marginRight: '10px', fontSize: '14px' }}>
                    圈子
                </span>
                <Group
                    disabled={getIdFromURL()}
                    value={props.groupId}
                    onChange={props.groupIdChange}></Group>
            </div>
            <br />
            <ScheduledPublishTime
                releaseType={props.releaseType}
                releaseTypeChange={props.releaseTypeChange}
                releaseTime={props.releaseTime}
                releaseTimeChange={props.releaseTimeChange}
            />
        </div>
    );
};
